<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color:#2284ab">{{title}}</h5>
      </div>
      <div class="body-content"> 

          
          <!-- <b-row class="mt-2">
            <b-col style="text-align:right">
                <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
                <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
                <b-button variant="success" @click="survey.completeLastPage()" v-if="survey.isLastPage && survey.mode != 'display'">Complete</b-button>
                <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button>
            </b-col>
          </b-row> -->
          <div style="padding: 10px;
                    border: 2px solid #c4c6be;
                    border-radius: 15px;"  class="mt-2">
                
            <survey :survey="survey"></survey>
            
            <hr/>
            <b-row class="mt-2">
              <b-col>
                  Page {{survey.currentPageNo + 1}} of {{survey.visiblePageCount}}
              </b-col>
              <b-col style="text-align:right">
                  <b-button @click="survey.prevPage()" v-if="!survey.isFirstPage">Previous</b-button>
                  <b-button variant="info" @click="survey.nextPage()" v-if="!survey.isLastPage">Next</b-button>
                  <!-- <b-button variant="success" @click="survey.completeLastPage()" v-if="survey.isLastPage && survey.mode != 'display'">Save & Add New</b-button> -->
                  <b-button variant="outline-success" @click="survey.completeLastPage()" v-if="survey.isLastPage && survey.mode != 'display'">Save</b-button>
                  <!-- <b-button variant="success" @click="pdfDownload()" v-if="survey.isLastPage && survey.mode != 'display'">Download PDF</b-button> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                <b-alert :show = "showDismissibleAlert" dismissible 
                    @dismissed="showDismissibleAlert=false"
                    
                    :variant="variant">
                    {{alertText}}
                </b-alert>
              </b-col>
            </b-row>
          </div>

        
      </div>
    </div>
  </b-container>
</template>
<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as SurveyVue from "survey-vue";
import Bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import router from "@/router";
import store from "@/store";
import data from "@/data";
import axios from "axios";
import lambda from "@/apis/lambda";

var Survey = SurveyVue.Survey;
Survey.cssType = "bootstrap";
SurveyVue.defaultBootstrapCss.navigationButton = "btn btn-green";

var surveyJSON = {};
var survey = new SurveyVue.Model(surveyJSON);
survey.cssType = "bootstrap";
survey.showNavigationButtons = false;
survey.sendResultOnPageNext = true;

export default {
  components: { Survey, Spinner },
  props: ["entityType", "entityId", "reset",'form_data'],
  watch: {
    entityId(newValue, oldValue) {
      this.regId = this.entityId;
      this.loadData();
    },
    reset(newValue, oldValue) {
      this.showDismissibleAlert=false;
      if (newValue=="true" || newValue==true) {
        this.survey.clear();
        this.survey.render();
      }
    }
  },
  data() {
    return {
      regId: "00000000-0000-0000-0000-000000000000",
      title: "REGISTRATION OF SECURITY GUARDS WORKING WITH  PRIVATE AGENCY",
      survey: survey,
      isLoading: false,
      variant: "success",
      alertText: "",
      showDismissibleAlert: false,
      show: true
    };
  },
  methods: {
    loadData() {
        this.survey.data = JSON.parse(this.form_data.GuardProfile);
        this.survey.currentPageNo = 0;
        this.survey.showCompletedPage = false;
    //   let promise = apis.ReadRegistrationDetailsOnbehalf(
    //     //this.entityId,
    //     this.regId,
    //     this.entityType
    //   );

    //   promise
    //     .then(response => {
    //       if (
    //         response.status == 200 &&
    //         response.body != "Error in Registration"
    //       ) {
    //         this.$store.dispatch("setRegID", response.body.RegistrationID);
    //         alert(response.body.FormDetails)
    //         this.survey.data = JSON.parse(response.body.FormDetails);
    //         if (response.body.IsComplete) {
    //           this.survey.showCompletedPage = false;

    //           this.survey.currentPageNo = 0;
    //           if (response.body.IsPaid) {
    //             //alert(response.body.IsPaid);
    //             this.survey.mode = "display";
    //           }
    //         } else {
    //           if (response.body.FormDetails == null) {
    //             this.survey.currentPageNo = 0;
    //           } else {
    //             this.survey.currentPageNo = response.body.LastCompletePage + 1;
    //           }
    //         }
    //       } else {
    //         this.survey.currentPageNo = 0;
    //       }
    //     })
    //     .catch(err => {
    //       alert("Error In Loading previous Details.");
    //     });
    },
    onSubmit() {
      //alert("The results are:" + JSON.stringify(this.survey.data));
    },
    onReset() {},

    SaveData(survey, pagenum, iscomplete) {
        // alert(1);
      this.isLoading = true;
      this.showDismissibleAlert = false;
      let pmtObj = {};
      let entityName = "";
      var userinfo = this.$store.getters.loggedUser;
      let surveyJSON = {};
      if (this.entityType == 11) {
        pmtObj.pmtPurpose = "Registration of Principal Employer";
        entityName = survey.data.EmployerName;
      } else if (this.entityType == 12) {
        pmtObj.pmtPurpose =
          "Registration of Security Guards Working with Private Agency";
        entityName = survey.data.name;
      }

      pmtObj.boardId = survey.data.Board;

      this.$store.dispatch("setPmtObject", pmtObj);
      this.$store.dispatch("setRegistrationDetails", survey.data);
    
    var payload = {
        ExemptionGuardID: this.form_data.ExemptionGuardID, //"00000000-0000-0000-0000-000000000000",
        CreatedUser: "00000000-0000-0000-0000-000000000000",
        GuardProfile: JSON.stringify(survey.data),
        ExemptionApplicationID: this.form_data.ExemptionApplicationID,
        GuardRegistraionID: this.form_data.GuardRegistraionID,
        RegistrationType: this.entityType,
        BoardID: survey.data.Board,
        ExemptionEmployerID: this.form_data.ExemptionEmployerID,
        EntityName: entityName
      };
    //   console.log(payload);
    // return;
      //var regId = this.$store.getters.getRegId;
    //   var payload = {
    //     ExemptionGuardID: this.form_data.ExemptionGuardID, //"00000000-0000-0000-0000-000000000000",
    //     CreatedUser: "00000000-0000-0000-0000-000000000000",
    //     GuardProfile: JSON.stringify(survey.data),
    //     ExemptionApplicationID: this.entityId,
    //     GuardRegistraionID: this.form_data.GuardRegistraionID,
    //     RegistrationType: this.entityType,
    //     BoardID: survey.data.Board,
    //     ExemptionEmployerID: this.form_data.ExemptionEmployerID,
    //     EntityName: entityName
    //   };
      
      let promise = apis.SavestgRegistrationDetails(payload);
      promise
        .then(response => {
          
          if (
            response.status == 200 &&
            response.body != "Error in Registration"
          ) {
            //this.$store.dispatch("setRegID", response.body);
            this.regId = response.body;
            
            if (iscomplete) {
              this.survey.clear();
              this.survey.render();
              this.regId = "00000000-0000-0000-0000-000000000000";
            }
            this.alertText = "Record Saved Successfully";
            this.showDismissibleAlert = true;
          } else {
            this.survey.currentPage = pagenum;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          if (pagenum == -1) {
            pagenum = 0;
          }
          this.survey.currentPage = pagenum;
          //console.log("Reponse", err.body);
          //alert("Error");
        });
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let surveyJSON = {};
    if (this.entityType == 11) {
      this.title = "REGISTRATION OF PRINCIPAL EMPLOYER";
      surveyJSON = data.Employer;
    } else if (this.entityType == 12) {
      this.title = "REGISTRATION OF SECURITY GUARD WORKING WITH PRIVATE AGENCY";
      //surveyJSON = data.PrivateGuardOnBehalf;
      surveyJSON = data.PrivateGuard;
    } else {
      this.alertText =
        "You have started a wrong page. Please proceed to Home page";
      this.variant = "warning";
      this.showDismissibleAlert = true;
    }

    this.survey = new SurveyVue.Model(surveyJSON);
    this.survey.cssType = "bootstrap";
    this.survey.showNavigationButtons = false;
    this.survey.sendResultOnPageNext = true;
    this.survey.onPartialSend.add(survey => {
      this.SaveData(survey, survey.currentPageNo, false);
    });
    this.survey.onComplete.add((survey, options) => {
      survey.clear(false);
      if (survey.mode == "display") {
        survey.currentPage = 0;
        return;
      }
      //sendDataToServer(survey, survey.currentPageNo, true);
      this.SaveData(survey, survey.currentPageNo, true);
      this.$root.$emit("bv::hide::modal", "modalNewGuard");
      //router.push("/agencypayment");
    });

    this.survey.onUploadFiles.add((survey, options) => {
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      var filetype = options.files[0].type;
      //console.log("Options", options);
      //var filepath = "CourtOrder_." + extn;
      var filepath = options.name + "_" + options.files[0].name;
      let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      promisefoto
        .then(response => {
          let signedUrl = response;
          var upldoptions = {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": options.files[0].type
            }
          };
          return axios.put(signedUrl, options.files[0], upldoptions);
        })
        .then(res => {
          if (res.status == 200) {
            options.callback(
              "success",
              options.files.map(file => {
                return {
                  file: file,
                  //content: data[file.name]
                  content:
                    "https://s3.ap-south-1.amazonaws.com/sgbimages/" +
                    userid +
                    "/" +
                    filepath
                };
              })
            );
          } else {
            this.variant = "warning";
            this.alertText = "Error in uploading Image";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";

          this.isLoading = false;
        });
    });

    if (this.entityId != "00000000-0000-0000-0000-000000000000") {
      this.loadData();
    }
  }
};
</script>
<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
h4 {
  font-size: 1rem !important;
}
h5 {
  font-size: 0.875rem !important;
}
.form-control {
  font-size: 0.75rem;
}
.btn sv_prev_btn {
  color: "red";
}
</style>


// WEBPACK FOOTER //
// src/components/OtherRegistrations/RegisterOnbehalfStg.vue